import React, {useEffect, useState} from 'react';
import {useAuth} from "../../authentication";
import {useSelector} from "react-redux";
import beApis from "src/util/apis/be";
import {useIntl} from "react-intl";
import IntlMessages from "../../util/IntlMessages";
import {Button, Card, Col, Divider, Flex, message, Row, Space, Table, Tag, Typography} from "antd";
import {convertDateFormat, getDeviceName} from 'src/util/common';

import './index.css';
import StyledAccessModeCardItem from "../../components/StyledAccessModeCardItem";
import AccessOpen from "../../assets/svg/AccessOpen";
import AccessClose from "../../assets/svg/AccessClose";
import ToastWarn from "../../assets/svg/ToastWarn";
import ToastSuccess from "../../assets/svg/ToastSuccess";
import {usePopup} from "../../util/use-popup";
import AccessModePopup from "./AccessModePopup";
import MessageReceived from "../../assets/svg/MessageReceived";
import AtomicButton from "../../components/AtomicButton";
import NewMessage from "../../assets/svg/NewMessage";

const {Text} = Typography;

const AccessApproval = () => {
  const {authUser, userSignOut} = useAuth();
  const intl = useIntl();
  const csSelected = useSelector(({cs}) => cs.csSelected);
  const activeAgents = useSelector(({cs}) => cs.activeAgents);
  const {confirmPopup, infoPopup} = usePopup();

  const [data, setData] = useState([]);
  const [recentlyData, setRecentlyData] = useState([]);
  const [selectedAllowedDevice, setSelectedAllowedDevice] = useState(false);
  const [hostUser, setHostUser] = useState();
  const [permissionList, setPermissionList] = useState([]);
  const [selectedMode, setSelectedMode] = useState("open");
  const [accessMode, setAccessMode] = useState({});
  const [name, setName] = useState("");

  const [pageSize, setPageSize] = useState(5);
  const [current, setCurrent] = useState(1);
  const [total, setTotal] = useState(0);
  const [recentlyTotal, setRecentlyTotal] = useState(0);
  const [ordering, setOrdering] = useState([]);
  const [focus, setFocus] = useState(false);

  const getFeatures = (is_open) => {
    if (is_open) {
      return [
        intl.formatMessage({id: "vlink.settings.access.open.features.all"}),
        intl.formatMessage({id: "vlink.settings.access.open.features.record"}),
        intl.formatMessage({id: "vlink.settings.access.open.features.simple"}),
      ]
    } else {
      return [
        intl.formatMessage({id: "vlink.settings.access.restricted.features.registered"}),
        intl.formatMessage({id: "vlink.settings.access.restricted.features.manual"}),
      ]
    }
  }

  const accessModeList = [
    {
      key: 'open',
      title: intl.formatMessage({id: "vlink.settings.access.open"}),
      description: intl.formatMessage({id: "vlink.settings.access.open.description"}),
      features: getFeatures(true),
      icon: <AccessOpen/>,
    },
    {
      key: 'restricted',
      title: intl.formatMessage({id: "vlink.settings.access.restricted"}),
      description: intl.formatMessage({id: "vlink.settings.access.restricted.description"}),
      features: getFeatures(false),
      icon: <AccessClose/>,
    }
  ];

  useEffect(() => {
    setFocus(true);
  }, [])

  useEffect(() => {
    const {access_mode} = authUser.settings || {};
    setSelectedMode(access_mode?.is_open ? "open" : "restricted")
  }, [authUser]);
  // useEffect(() => {
  //   if (hostUser) {
  //     setPermissionList(hostUser.product_permissions.sort())
  //   }
  // }, [hostUser])

  useEffect(() => {
    if (focus) {
      getData();
      getRecentlyData();
    }
  }, [focus, pageSize, current])

  const getData = () => {

    const req = {
      is_requested: true,
      status: "need_to_approve",
      approved_at__isnull: ""
    }

    beApis.allowedDevices(csSelected.host, req, current, pageSize).then(resp => {
      setData(resp.results);
      setTotal(resp.count);
    }).catch((e) => console.log("loginHistory error", e))
  }

  const getRecentlyData = () => {
    // const weekAgo = new Date();
    // weekAgo.setDate(weekAgo.getDate() - 7);
    // const weekAgoString = weekAgo.toISOString().split('T')[0]; // YYYY-MM-DD 형식

    const req = {
      "is_requested": true,
      "recently": true,
      "status__in": ["approved", "denied", "expired"],
    }

    beApis.allowedDevices(csSelected.host, req, current, 99999).then(resp => {
      setRecentlyData(resp.results);
      setRecentlyTotal(resp.count);
    }).catch((e) => console.log("loginHistory error", e))
  }

  const AgentStatusComponent = ({icon, text}) => (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      marginRight: 16,
    }}>
      {icon}
      <span style={{margin: '0 4px'}}>
        <IntlMessages id={text}/>
      </span>
    </div>
  )

  const handleApproval = (r, isApproved) => {
    const values = {
      is_approved: isApproved,
    }
    beApis.updateAllowedDevice(csSelected.host, r.id, values).then((resp) => {
      if (isApproved) {
        message.success({
          content: intl.formatMessage({id: 'vlink.settings.access.approved'}),
          icon: <ToastSuccess/>,
        });
      } else {
        message.warning({
          content: intl.formatMessage({id: 'vlink.settings.access.rejected'}),
          icon: <ToastWarn/>,
        });
      }
      getData();
      getRecentlyData();
    })
  }
// JS/TS 공용
  const withCommonOnCell = (cols, {defaultMinWidth = 120} = {}) =>
    cols.map(col => {
      const prevOnCell = col.onCell;

      return {
        ...col,
        onCell: (record, rowIndex) => {
          // 기존 onCell 결과/스타일 보존
          const prev = typeof prevOnCell === 'function' ? prevOnCell(record, rowIndex) : {};
          const prevStyle = (prev && prev.style) || {};

          // col.maxWidth: 컬럼별로 다르게 지정 (커스텀 프로퍼티)
          const cellStyle = {
            minWidth: col.minWidth ?? defaultMinWidth,
            maxWidth: col.maxWidth,            // ← 컬럼별로 다르게 줄 포인트
            ...prevStyle,
          };

          return {...prev, style: cellStyle};
        },
      };
    });
  const baseColumns = [
    {
      title: intl.formatMessage({id: 'vlink.settings.access.client'}),
      dataIndex: 'client',
      key: 'client',
      maxWidth: 170,           // 컬럼별 maxWidth 다르게
      render: (t, r) => (
        <Text ellipsis={{rows: 1, tooltip: true}}
              style={{display: 'inline-block', maxWidth: '100%', verticalAlign: 'middle'}}>
          {getDeviceName(r.client) || intl.formatMessage({id: 'vlink.login.device.unknown'})}
        </Text>
      ),
    },
    // {
    //   title: intl.formatMessage({id: 'vlink.settings.access.location'}),
    //   dataIndex: 'location',
    //   key: 'location',
    //   maxWidth: 190,
    //   render: (t, r) => (
    //     <Text ellipsis={{rows: 1, tooltip: true}}
    //           style={{display: 'inline-block', maxWidth: '100%', verticalAlign: 'middle'}}>
    //       {r.geo_data?.location || intl.formatMessage({id: 'vlink.login.device.unknown'})}
    //     </Text>
    //   ),
    // },
    {
      title: intl.formatMessage({id: 'vlink.settings.access.ip'}),
      dataIndex: 'ip',
      key: 'ip',
      maxWidth: 130,
      render: (t, r) => (
        <Text ellipsis={{rows: 1, tooltip: true}}
              style={{display: 'inline-block', maxWidth: '100%', verticalAlign: 'middle'}}>
          {r.ip || intl.formatMessage({id: 'vlink.login.device.unknown'})}
        </Text>
      ),
    },
    {
      title: intl.formatMessage({id: 'vlink.settings.access.requestTime'}),
      dataIndex: 'created_at',
      key: 'created_at',
      maxWidth: 130,
      render: (t, r) =>
        <Text ellipsis={{rows: 1, tooltip: true}}
              style={{display: 'inline-block', maxWidth: '100%', verticalAlign: 'middle'}}>{
          convertDateFormat(r.geo_data.connected_at)
        }</Text>
    },
    {
      title: intl.formatMessage({id: 'vlink.settings.access.message'}),
      dataIndex: 'message',
      key: 'message',
      minWidth: 100,
      maxWidth: 130,
      align: 'center',
      render: (t, r) => {
        return <div style={{justifyContent: 'center', display: 'flex', alignItems: 'flex-start'}}>
          {r.message ?
            <AtomicButton icon={<MessageReceived/>} type="text" onClick={() => setSelectedAllowedDevice(r)}/> : null}
          <div style={{opacity: r.message && !r.message_read_at ? 1 : 0}}><NewMessage/></div>
        </div>
      },
    },
    {
      title: intl.formatMessage({id: 'vlink.settings.access.task'}),
      key: 'task',
      // 버튼 컬럼은 maxWidth 안줄 수도 있음 (원하면 maxWidth: 180 등 지정)
      render: (t, r) => (
        <Space>
          <Button onClick={() => handleApproval(r, false)}><IntlMessages id="vlink.common.deny"/></Button>
          <Button type={'primary'} onClick={() => handleApproval(r, true)}><IntlMessages
            id="vlink.button.approval"/></Button>
        </Space>
      ),
    },
  ];

  const columns = withCommonOnCell(baseColumns, {defaultMinWidth: 30});

  const recentlyColumns = [
    {
      key: 'client',
      width: '10%',
      render: (t, r) => (
        <Text ellipsis={{rows: 1, tooltip: true}}
              style={{display: 'inline-block', maxWidth: '100%', verticalAlign: 'middle', padding: '10px 32px'}}>
          {getDeviceName(r.client) || intl.formatMessage({id: 'vlink.login.device.unknown'})}
        </Text>
      ),
    },
    {
      key: 'ip',
      width: '100%',
      render: (t, r) => (
        <Text ellipsis={{rows: 1, tooltip: true}}
              style={{display: 'inline-block', maxWidth: '100%', verticalAlign: 'middle'}}>
          {r.ip || intl.formatMessage({id: 'vlink.login.device.unknown'})}
        </Text>
      ),
    },
    {
      key: 'approved_at',
      width: 200,
      render: (t, r) => {
        return (
          <Text ellipsis={{rows: 1, tooltip: true}}
                style={{display: 'inline-block', maxWidth: '100%', verticalAlign: 'middle'}}>{
            convertDateFormat(r.approved_at || r.denied_at, 'withTime')
          }</Text>
        )
      }
    },
    {
      key: 'status',
      render: (t, r) =><Tag color={r.denied_at ? 'red' : 'green'} style={{ borderRadius: '20px', padding: '2px 16px', marginRight: 42}}>
        {r.denied_at ? <IntlMessages id="common.rejected"/> : <IntlMessages id="common.approved"/>}
      </Tag>
    },
  ];

  const AccessModeSelector = ({value, onChange}) => (
    <div style={{width: "100%", maxWidth: 1200, margin: "0 auto"}}>
      <Row gutter={24}>
        {accessModeList.map((item) => (
          <Col key={item.key} xs={24} md={12}>
            <StyledAccessModeCardItem
              checked={value === item.key}
              onClick={() => onChange(item.key)}
              title={item.title}
              description={item.description}
              features={item.features}
              icon={item.icon}
            />
          </Col>
        ))}
      </Row>
    </div>
  );


  const onMovePage = (current) => {
    setCurrent(current);
  }

  const onChangeSize = (size) => {
    setPageSize(size);
  }

  const handleChange = (p, f, sorter) => {
    if (sorter.column) {
      const order = sorter.order === "ascend" ? sorter.column.dataIndex : "-" + sorter.column.dataIndex;
      setOrdering([order]);
    } else {
      setOrdering([]);
    }
  }
  const handleChangeAccessMode = (value) => {

    if (!authUser?.parent_id) {
      return
    }
    const {access_mode} = authUser.settings || {};
    const values = {
      settings: {
        access_mode: {
          ...access_mode,
          is_open: value === "open",
        }
      }
    }
    beApis.updateSubUser(csSelected.host, authUser.parent_id, values).then((resp) => {
      // message.config({
      //   top: '0%',  // px나 % 사용 가능
      // });
      if (value === "open") {
        message.warning({
          content: intl.formatMessage({id: 'vlink.settings.access.changedToOpen'}),
          icon: <ToastWarn/>,
        });
      } else {
        message.success({
          content: intl.formatMessage({id: 'vlink.settings.access.changedToRestricted'}),
          icon: <ToastSuccess/>,
        });
      }
    }).catch((e) => {
      console.log("에러발생", e)
    })
    setSelectedMode(value);
  }

  return (
    <div style={{display: "flex", flexDirection: "column", gap: 20, height: "100%"}}>
      <Card title={<Flex justify='space-between' align="center">
        <div style={{display: 'flex', alignItems: 'center'}}>
          <IntlMessages id="vlink.settings.access.approval"/>
          <Text type="secondary" style={{marginLeft: 20, fontWeight: 400, color: '#181818', fontSize: 16}}>
            <IntlMessages id="home.totalCount"/><span
            style={{margin: '0 4px', color: '#df043a'}}>{total}</span><IntlMessages id="home.countUnit"/>
          </Text>
        </div>
        <Space>
          <Text style={{
            fontWeight: 400,
            fontSize: 16
          }}>{intl.formatMessage({id: "vlink.settings.access.reviewNewDevice"})}</Text>
        </Space>
      </Flex>}
            className="settings-card"
      >
        <Table
          className={'user-list'}
          columns={columns}
          dataSource={data}
          pagination={{
            position: ['bottomCenter'],
            current: current,
            total: total,
            pageSize: pageSize,
            onChange(current) {
              onMovePage(current)
            },
            onShowSizeChange(current, size) {
              onChangeSize(size)
            },

          }}
          rowKey='id'
          onChange={handleChange}
          // scroll={{x: 'max-content'}}  // 핵심!
        />
      </Card>
      <Card title={<Flex justify='space-between' align="center">
        <div style={{display: 'flex', alignItems: 'center'}}>
          <IntlMessages id="vlink.settings.access.recentProcessedRequests"/>
          <Text type="secondary" style={{marginLeft: 20, fontWeight: 400, color: '#181818', fontSize: 16}}>
            <IntlMessages id="home.totalCount"/><span
            style={{margin: '0 4px', color: '#df043a'}}>{recentlyTotal}</span><IntlMessages id="home.countUnit"/>
          </Text>
          <span>
            <Divider type="vertical" style={{ borderColor: '#181818', margin: '10px 8px'}} />
          </span>
          <Text type="secondary" style={{fontWeight: 400, color: '#181818', fontSize: 16}}>
            <IntlMessages id="common.sortByAdded"/>
          </Text>
        </div>
        <Space>
          <Text style={{
            fontWeight: 400,
            fontSize: 16
          }}>{intl.formatMessage({id: "vlink.settings.access.recentProcessedRequestsDesc"})}</Text>
        </Space>
      </Flex>}
            className="settings-card"
      >
        <Table
          className="no-hover-table"
          columns={recentlyColumns}
          dataSource={recentlyData}
          pagination={false}
          showHeader={false}
          rowClassName={(record, index) => {
            return 'custom-row-border';
          }}
          rowKey='id'
        />
      </Card>
      {selectedAllowedDevice &&
        <AccessModePopup isMessageMode
                         selectedAllowedDevice={selectedAllowedDevice}
                         onOk={() => {
                           setSelectedAllowedDevice(false);
                         }}
                         onCancel={() => {
                           setSelectedAllowedDevice(false)
                         }}
                         refreshData={getData}
        />
      }
    </div>
  )

}

export default AccessApproval;
